import { GraphQLEnumType } from 'graphql'

export type RuleSeverity = 'NOTE' | 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL'

export const RuleSeverityType = new GraphQLEnumType({
  name: 'RuleSeverity',
  description: 'The severity for a rule',
  values: {
    NOTE: {
      value: 'NOTE'
    },
    LOW: {
      value: 'LOW'
    },
    MEDIUM: {
      value: 'MEDIUM'
    },
    HIGH: {
      value: 'HIGH'
    },
    CRITICAL: {
      value: 'CRITICAL'
    }
  }
})
